export default __webpack_public_path__ + "static/media/africainevie-min.6fa3ed9b.webp";